// extracted by mini-css-extract-plugin
export default {"wraperBtn":"StaticPages_wraperBtn__1yqg2","tableContainer":"StaticPages_tableContainer__wJSkW","defaultEditor":"StaticPages_defaultEditor__dqEG6","row":"StaticPages_row__w27Ex"};